import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Table, Spin, message } from 'antd';
import {
  TeamOutlined,
  LinkOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  DollarOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import apiClient from '../services/api';

const Affiliate = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/admin/affiliate/stats');
      setStats(res.data);
    } catch {
      message.error('Failed to load affiliate stats');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;

  const topColumns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Links', dataIndex: 'affiliate_links_count', key: 'affiliate_links_count' },
    {
      title: 'Earnings',
      dataIndex: 'affiliate_earnings',
      key: 'affiliate_earnings',
      render: (v) => `$${(v || 0).toFixed(2)}`,
    },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Total Affiliates"
              value={stats?.total_affiliates || 0}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Total Links"
              value={stats?.total_links || 0}
              prefix={<LinkOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Total Clicks"
              value={stats?.total_clicks || 0}
              prefix={<EyeOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Conversions"
              value={stats?.total_conversions || 0}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Commission Paid"
              value={`$${(stats?.total_commission_paid || 0).toFixed(2)}`}
              prefix={<DollarOutlined />}
            />
          </Card>
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Card>
            <Statistic
              title="Pending"
              value={`$${(stats?.pending_commission || 0).toFixed(2)}`}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>
      <Card title="Top Affiliates" style={{ marginTop: 16 }}>
        <Table
          columns={topColumns}
          dataSource={stats?.top_affiliates || []}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </>
  );
};

export default Affiliate;
